import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        toastText: '',
        loadingVisible: false
    },
    mutations: {
        increment(state) {
            state.count++
        },
        toast(state, text) {
            state.toastText = text
            setTimeout(() => {
                state.toastText = ''
            }, 2000)
        },
        loading(state, loadingVisible) {
            state.loadingVisible = loadingVisible
        },

    }
})


// WEBPACK FOOTER //
// ./src/store/index.js